import React from 'react'

const FreeIfConditions = () => (
  <div>
    <h2 id='free-if'>Free If</h2>
    <p><img src='https://d2r3bolva79zkl.cloudfront.net/assets/free-if-label.en.png' alt='' /></p>
    <p><strong>When you book with us, we want you to feel confident that you’ve bagged yourself a great deal</strong>. So, if you find the same product you bought through us cheaper somewhere else, we’ll give it to you free - so long as it qualifies under our <a href='https://www.holidayextras.co.uk/free-if-full-terms.html' target='_blank' title='Free If terms and conditions'>Free If</a> terms and conditions</p>
  </div>
)

export default FreeIfConditions



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/freeifconditions.jsx